/* ==========================================================================
   Dutch Hollandia — interactions
   Kept intentionally light. One orchestrated page-load moment, then
   hover- and scroll-driven only.
   ========================================================================== */

(function () {
  const $  = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  // ---------- Header: shrink on scroll ----------
  const header = $('[data-header]');
  let lastY = 0;
  const onScroll = () => {
    const y = window.scrollY;
    if (y > 12) header.classList.add('is-scrolled');
    else        header.classList.remove('is-scrolled');
    lastY = y;
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // ---------- Cart drawer ----------
  const cart = $('[data-cart]');
  $$('[data-cart-open]').forEach(b => b.addEventListener('click', () => {
    cart.classList.add('is-open');
    cart.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }));
  $$('[data-cart-close]').forEach(b => b.addEventListener('click', () => {
    cart.classList.remove('is-open');
    cart.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }));

  // ---------- Mobile menu ----------
  const menu = $('[data-menu]');
  $$('[data-menu-open]').forEach(b => b.addEventListener('click', () => {
    menu.classList.add('is-open');
    menu.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }));
  $$('[data-menu-close]').forEach(b => b.addEventListener('click', () => {
    menu.classList.remove('is-open');
    menu.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }));
  $$('.mob-menu nav a').forEach(a => a.addEventListener('click', () => {
    menu.classList.remove('is-open');
    document.body.style.overflow = '';
  }));

  // Escape closes overlays
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    if (cart.classList.contains('is-open')) {
      cart.classList.remove('is-open'); document.body.style.overflow = '';
    }
    if (menu.classList.contains('is-open')) {
      menu.classList.remove('is-open'); document.body.style.overflow = '';
    }
  });

  // ---------- Hero: single orchestrated page-load moment ----------
  const reveals = $$('[data-reveal]');
  // Stagger reveal on next frame
  requestAnimationFrame(() => {
    reveals.forEach((el, i) => {
      setTimeout(() => el.classList.add('is-in'), 80 * i);
    });
  });

  // ---------- Hero: photo parallax to cursor (subtle) ----------
  // querySelectorAll so this works when more than one hero-style section
  // (e.g. Hero and Hero 2) is on the page at once -- each stage/tilt pair
  // gets its own independent state. The tilt offset is written as CSS
  // custom properties rather than a full `transform` overwrite, so each
  // section's own base transform (e.g. Hero's rotate(-3deg)) stays intact.
  $$('[data-parallax]').forEach((stage) => {
    const tilt = stage.querySelector('[data-tilt]');
    if (!tilt || !window.matchMedia('(hover: hover)').matches) return;

    let raf = null;
    let targetX = 0, targetY = 0;
    let currentX = 0, currentY = 0;

    stage.addEventListener('mousemove', (e) => {
      const r = stage.getBoundingClientRect();
      const dx = (e.clientX - (r.left + r.width / 2)) / r.width;   // -0.5..0.5
      const dy = (e.clientY - (r.top  + r.height / 2)) / r.height; // -0.5..0.5
      targetX = dx * 16;   // px translate range
      targetY = dy * 16;
      if (!raf) raf = requestAnimationFrame(loop);
    });
    stage.addEventListener('mouseleave', () => {
      targetX = 0; targetY = 0;
      if (!raf) raf = requestAnimationFrame(loop);
    });
    function loop() {
      currentX += (targetX - currentX) * 0.08;
      currentY += (targetY - currentY) * 0.08;
      tilt.style.setProperty('--tilt-x', currentX + 'px');
      tilt.style.setProperty('--tilt-y', currentY + 'px');
      if (Math.abs(targetX - currentX) > 0.05 || Math.abs(targetY - currentY) > 0.05) {
        raf = requestAnimationFrame(loop);
      } else {
        raf = null;
      }
    }
  });

  // ---------- Product finder: match on selection ----------
  const finder = $('[data-finder]');
  if (finder) {
    const resultBox = $('[data-finder-result]');
    const empty = resultBox.querySelector('.finder__empty');
    const match = resultBox.querySelector('.finder__match');
    const titleEl = match.querySelector('[data-result-title]');
    const descEl  = match.querySelector('[data-result-desc]');
    const imgEl   = match.querySelector('[data-result-image]');
    const priceEl = match.querySelector('[data-result-price]');
    const linkEl  = match.querySelector('[data-result-link]');

    const sizeNote = { small: ' Small size.', mid: ' Medium size.', large: ' Large size.' };

    finder.addEventListener('change', () => {
      const q1 = finder.querySelector('input[name="q1"]:checked');
      const q2 = finder.querySelector('input[name="q2"]:checked');
      if (!q1) return;

      titleEl.textContent = q1.dataset.title || '';
      descEl.textContent  = (q1.dataset.desc || '') + (q2 ? (sizeNote[q2.value] || '') : '');
      if (q1.dataset.image) imgEl.src = q1.dataset.image;
      priceEl.textContent = q1.dataset.price || '';
      if (linkEl && q1.dataset.link) linkEl.href = q1.dataset.link;

      empty.hidden = true;
      match.hidden = false;
    });
  }

  // ---------- Newsletter fake submit ----------
  const joinForm = $('.joinpack__form');
  if (joinForm) {
    joinForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const btn = joinForm.querySelector('button');
      btn.textContent = 'Welcome to the pack ✦';
      btn.disabled = true;
      joinForm.querySelector('input').value = '';
    });
  }

  // ---------- Horizontal scroll: drag on desktop for review carousel ----------
  $$('[data-hscroll]').forEach(el => {
    let isDown = false, startX, scrollLeft;
    el.addEventListener('mousedown', (e) => {
      isDown = true; el.classList.add('is-dragging');
      startX = e.pageX - el.offsetLeft;
      scrollLeft = el.scrollLeft;
    });
    ['mouseleave','mouseup'].forEach(ev => el.addEventListener(ev, () => {
      isDown = false; el.classList.remove('is-dragging');
    }));
    el.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - el.offsetLeft;
      el.scrollLeft = scrollLeft - (x - startX) * 1.5;
    });
  });
})();

/* --- Shopify: intercept product form submits to add via cart API and open drawer --- */
(function(){
  document.addEventListener('submit', async function(e){
    const form = e.target;
    if (!form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const originalText = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.innerHTML = 'Adding…'; }
    try {
      const fd = new FormData(form);
      const res = await fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } });
      if (!res.ok) throw new Error('Add to cart failed');
      // Refresh cart drawer
      const drawer = document.querySelector('[data-cart]');
      if (drawer) {
        const html = await fetch('/?section_id=cart-drawer').then(r => r.text());
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-cart]');
        if (fresh) drawer.innerHTML = fresh.innerHTML;
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      }
      if (btn) { btn.innerHTML = 'Added ✓'; setTimeout(() => { btn.innerHTML = originalText; btn.disabled = false; }, 1200); }
    } catch (err) {
      if (btn) { btn.innerHTML = originalText; btn.disabled = false; }
      console.error(err);
    }
  });
})();

/* --- Live cart line quantity steppers (drawer): call /cart/change.js, refresh drawer + cart badge --- */
(function(){
  document.addEventListener('click', async function(e){
    const btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    const wrap = btn.closest('[data-qty]');
    if (!wrap) return;
    const key = wrap.getAttribute('data-qty');
    const display = wrap.querySelector('span');
    const current = parseInt(display.textContent, 10) || 0;
    const next = Math.max(0, current + parseInt(btn.getAttribute('data-qty-change'), 10));
    wrap.querySelectorAll('button').forEach(b => b.disabled = true);
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: next })
      });
      if (!res.ok) throw new Error('Cart update failed');
      const drawer = document.querySelector('[data-cart]');
      if (drawer) {
        const html = await fetch('/?section_id=cart-drawer').then(r => r.text());
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-cart]');
        const wasOpen = drawer.classList.contains('is-open');
        if (fresh) drawer.innerHTML = fresh.innerHTML;
        if (wasOpen) drawer.classList.add('is-open');
      }
      if (document.querySelector('[data-cart-page]')) window.location.reload();
    } catch (err) {
      console.error(err);
    }
  });
})();

/* --- Standalone quantity stepper (product page add-to-cart form) ---------- */
(function(){
  document.addEventListener('click', function(e){
    const btn = e.target.closest('[data-qty-step]');
    if (!btn) return;
    const wrap = btn.closest('[data-qty-input]');
    if (!wrap) return;
    const input = wrap.querySelector('input[type="number"]');
    const min = parseInt(input.min, 10) || 1;
    const step = parseInt(btn.getAttribute('data-qty-step'), 10);
    const next = Math.max(min, (parseInt(input.value, 10) || min) + step);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
})();

/* --- Product variant picker: swap image, price, availability, sync hidden id input --- */
(function(){
  const forms = Array.from(document.querySelectorAll('[data-product-form]'));
  forms.forEach(form => {
    const dataEl = form.querySelector('[data-product-json]');
    if (!dataEl) return;
    let product;
    try { product = JSON.parse(dataEl.textContent); } catch (err) { return; }

    const idInput   = form.querySelector('input[name="id"]');
    const priceEl   = form.querySelector('[data-product-price]');
    const compareEl = form.querySelector('[data-product-compare-price]');
    const addBtn    = form.querySelector('[data-add-to-cart]');
    const mainImg   = document.querySelector('[data-product-main-image]');

    function money(cents) {
      return '₹' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    }

    function selectedOptions() {
      return Array.from(form.querySelectorAll('[data-option-index]'))
        .sort((a, b) => a.getAttribute('data-option-index') - b.getAttribute('data-option-index'))
        .map(group => {
          const checked = group.querySelector('input:checked');
          return checked ? checked.value : null;
        });
    }

    function findVariant(options) {
      return product.variants.find(v => v.options.every((o, i) => o === options[i]));
    }

    function updateForOptions() {
      const options = selectedOptions();
      const variant = findVariant(options);

      form.querySelectorAll('[data-option-value]').forEach(el => {
        const group = el.closest('[data-option-index]');
        const idx = parseInt(group.getAttribute('data-option-index'), 10);
        const testOptions = options.slice();
        testOptions[idx] = el.getAttribute('data-option-value');
        const testVariant = findVariant(testOptions);
        el.classList.toggle('is-unavailable', !testVariant || !testVariant.available);
      });

      if (!variant) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
        return;
      }

      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = money(variant.price);
      if (compareEl) {
        if (variant.compare_at_price > variant.price) {
          compareEl.textContent = money(variant.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? addBtn.getAttribute('data-label-add') : 'Sold out';
      }
      if (mainImg && variant.featured_image) {
        mainImg.src = variant.featured_image.src.replace(/(\.[a-z]+)(\?|$)/i, '_1200x$1$2');
        const thumb = document.querySelector(`[data-thumb][data-media-id="${variant.featured_image.id}"]`);
        if (thumb) thumb.click();
      }
    }

    form.addEventListener('change', (e) => {
      if (e.target.matches('[data-option-value]')) updateForOptions();
    });
    updateForOptions();
  });
})();

/* --- Product gallery: thumbnail click swaps main image --- */
(function(){
  document.querySelectorAll('[data-product-gallery]').forEach(gallery => {
    const main = gallery.querySelector('[data-product-main-image]');
    gallery.querySelectorAll('[data-thumb]').forEach(thumb => {
      thumb.addEventListener('click', () => {
        if (!main) return;
        main.src = thumb.getAttribute('data-full');
        gallery.querySelectorAll('[data-thumb]').forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  });
})();

/* --- Wishlist: client-side only, stored in localStorage by product handle -- */
(function(){
  const KEY = 'dh_wishlist';

  function getList() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (err) { return []; }
  }
  function setList(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (err) {}
  }
  function updateCount() {
    const count = getList().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(el => {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }
  function markButtons() {
    const list = getList();
    document.querySelectorAll('[data-wishlist]').forEach(btn => {
      btn.classList.toggle('is-active', list.indexOf(btn.getAttribute('data-wishlist')) !== -1);
    });
  }

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-wishlist]');
    if (!btn) return;
    e.preventDefault();
    const handle = btn.getAttribute('data-wishlist');
    let list = getList();
    if (list.indexOf(handle) !== -1) list = list.filter(h => h !== handle);
    else list.push(handle);
    setList(list);
    markButtons();
    updateCount();
    document.dispatchEvent(new CustomEvent('wishlist:change'));
  });

  markButtons();
  updateCount();
  window.DHWishlist = { getList, setList };
})();

/* --- Wishlist page: fetch each saved product and render a card ------------ */
(function () {
  const grid = document.querySelector('[data-wishlist-grid]');
  if (!grid) return;
  const emptyState = document.querySelector('[data-wishlist-empty]');

  function money(cents) {
    return '₹' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  }
  function withWidth(url, width) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  async function render() {
    const list = window.DHWishlist.getList();

    if (list.length === 0) {
      grid.innerHTML = '';
      if (emptyState) emptyState.hidden = false;
      return;
    }
    if (emptyState) emptyState.hidden = true;
    grid.innerHTML = '<p class="wishlist-loading">Loading your wishlist…</p>';

    const products = await Promise.all(list.map(handle =>
      fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(r => (r.ok ? r.json() : null))
        .catch(() => null)
    ));

    grid.innerHTML = '';
    const valid = products.filter(Boolean);
    if (valid.length === 0) {
      if (emptyState) emptyState.hidden = false;
      return;
    }

    valid.forEach(p => {
      const compare = p.compare_at_price > p.price ? money(p.compare_at_price) : null;
      const article = document.createElement('article');
      article.className = 'product';
      article.innerHTML = `
        <div class="product__media">
          <button class="product__wish is-active" data-wishlist="${p.handle}" aria-label="Remove from wishlist">
            <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M12 20s-7-4.35-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.65-7 10-7 10z"/></svg>
          </button>
          <a href="/products/${p.handle}" style="display:contents;">
            ${p.featured_image ? `<img class="product__img product__img--a" src="${withWidth(p.featured_image, 700)}" alt="${p.title.replace(/"/g, '&quot;')}" loading="lazy">` : ''}
          </a>
        </div>
        <div class="product__body">
          <h3 class="product__title"><a href="/products/${p.handle}" style="color:inherit;text-decoration:none;">${p.title}</a></h3>
          <p class="product__price"><span>${money(p.price)}</span>${compare ? ` <s>${compare}</s>` : ''}</p>
        </div>`;
      grid.appendChild(article);
    });
  }

  render();
  document.addEventListener('wishlist:change', render);
})();

/* --- Infinite marquees (announcement bar, hero band): true seamless loop -- */
/* Clones each track's message set enough times to always overflow the
   viewport by at least one full width, so the CSS loop never runs out of
   content and shows a blank gap before resetting -- a fixed "duplicate
   exactly twice" approach only works if one copy is wider than the screen.
   Speed is per-instance via each track's data-marquee-speed (px/second),
   settable in the theme editor. */
(function () {
  const tracks = document.querySelectorAll('[data-marquee-track]');
  if (!tracks.length) return;

  function setupTrack(track) {
    const original = track.querySelector('[data-marquee-set]');
    if (!original) return;

    track.querySelectorAll('[data-marquee-set]').forEach((el, i) => { if (i > 0) el.remove(); });

    const setWidth = original.getBoundingClientRect().width;
    if (!setWidth) return;

    const trackStyles = getComputedStyle(track);
    const gap = parseFloat(trackStyles.columnGap || trackStyles.gap) || 0;
    const containerWidth = track.parentElement.getBoundingClientRect().width;

    let totalWidth = setWidth;
    while (totalWidth < containerWidth * 2 + setWidth) {
      track.appendChild(original.cloneNode(true));
      totalWidth += setWidth + gap;
    }

    const pxPerSecond = parseFloat(track.getAttribute('data-marquee-speed')) || 60;
    track.style.setProperty('--marquee-distance', (setWidth + gap) + 'px');
    track.style.setProperty('--marquee-duration', (setWidth / pxPerSecond) + 's');
  }

  function setupAll() { tracks.forEach(setupTrack); }

  setupAll();
  window.addEventListener('resize', setupAll);
})();

/* --- Accordion (product page expandable sections) -------------------------- */
(function(){
  document.addEventListener('click', function(e){
    const trigger = e.target.closest('[data-accordion-trigger]');
    if (!trigger) return;
    const item = trigger.closest('[data-accordion-item]');
    if (!item) return;
    const wasOpen = item.classList.contains('is-open');
    item.closest('[data-accordion]').querySelectorAll('[data-accordion-item]').forEach(i => i.classList.remove('is-open'));
    if (!wasOpen) item.classList.add('is-open');
  });
})();
